import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * The one empty state: an icon, a short title and a one-line explanation of
 * why there is nothing here or what to do next. Same layout as HCP's
 * `arp-empty-state`, built from AgdPreset tokens.
 */
@Component({
  selector: 'app-empty-state',
  imports: [TranslocoPipe],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent {
  /** Material Symbols icon name. */
  readonly icon = input('inbox');
  /** Translation key for the title. */
  readonly title = input('DASHBOARD.EMPTY_STATE.NO_DATA_TITLE');
  /** Translation key for the one-line explanation. */
  readonly description = input('DASHBOARD.EMPTY_STATE.NO_DATA_DESC');
  readonly params = input<Record<string, unknown>>({});
}
